<template>
  <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.8333 13.3332C2.46664 13.3332 2.15275 13.2026 1.89164 12.9415C1.63053 12.6804 1.49997 12.3665 1.49997 11.9998V3.99984C1.49997 3.63317 1.63053 3.31928 1.89164 3.05817C2.15275 2.79706 2.46664 2.6665 2.8333 2.6665H13.5C13.8666 2.6665 14.1805 2.79706 14.4416 3.05817C14.7027 3.31928 14.8333 3.63317 14.8333 3.99984V11.9998C14.8333 12.3665 14.7027 12.6804 14.4416 12.9415C14.1805 13.2026 13.8666 13.3332 13.5 13.3332H2.8333ZM8.16664 8.6665L2.8333 5.33317V11.9998H13.5V5.33317L8.16664 8.6665ZM8.16664 7.33317L13.5 3.99984H2.8333L8.16664 7.33317ZM2.8333 5.33317V3.99984V11.9998V5.33317Z"
      fill="currentColor"
    />
  </svg>
</template>
